<template>
  <div class="message_datetime_area" :class="{'userMessage': userMessage, 'dateColor': isSimpleText }">
    <div>
        {{ renderDateTime_lastReplyTimestamp(dateTimeMessage.created, 'customReadable', false) }}
        <span v-if="dateTimeMessage.status == 'rejected' && dateTimeMessage.error_type && dateTimeMessage.error_type != null && dateTimeMessage.error_type != '' && dateTimeMessage.error_type != 'None'" style="color: #FA7554;">
            &nbsp;&nbsp; | &nbsp;&nbsp;
            Error: <a :href="dateTimeMessage.error_type" target="_blank" rel="noreferer noopener" class="hoverUnderline">Learn more</a>
        </span>
    </div>
  </div>
</template>

<script>
import { renderDateTime_lastReplyTimestamp } from '@/helpers/date.helpers';

export default {
  props: {
    dateTimeMessage: {
      type: Object,
      default: () => {
        return {};
      },
    },
    userMessage: {
      type: Boolean,
      default: false
    },
    isSimpleText: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  methods: {
    renderDateTime_lastReplyTimestamp,
  }
}
</script>

<style scoped>

.message_datetime_area{
  text-align: right;
}

.userMessage{
  text-align: left !important;
}

.dateColor{
  color: #ffffff !important;
}

.message_datetime_area {
  color: #54575E;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-top: 5px;
}
</style>